import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsLayoutPageResponse } from '../buildSportsLayoutPageResponse';

import {
  TXTWCL_Bet_on_the_N0_with_XXBrandXX_N_ELL,
  TXTWCL_N0_Match_Betting_X_N0_Match_Od_ELL
} from './sportsGolfCompetition.messages.json';

const sportsGolfCompetitionWidgets = [
  {
    title: 'Sports Golf Matches Widget',
    _content_type_uid: SportsWidgetType.SportsGolfMatches
  }
] satisfies readonly SectionWidgetConfig[];

export const sportsGolfCompetition = buildSportsLayoutPageResponse({
  alias: 'sportsGolfCompetition',
  seoConfig: {
    apiPath: '/meta/competition/',
    descriptionTag: TXTWCL_Bet_on_the_N0_with_XXBrandXX_N_ELL,
    redirectTo: 'sportsSport',
    redirectStatusCode: 302,
    titleTag: TXTWCL_N0_Match_Betting_X_N0_Match_Od_ELL,
    translationsMap: {
      sport: 'eventTypeName',
      competition: 'competitionName'
    }
  },
  mainSectionWidgetConfigs: sportsGolfCompetitionWidgets
});
